// Importaciones de React, React Router y el logo.
import React from 'react';
import { Link } from 'react-router-dom'; // Componente para crear enlaces de navegación interna.
import logo from '../img/logo.png';

/**
 * Componente NotFoundPage.
 * Muestra una página de error 404 cuando el usuario intenta acceder a una ruta que no existe.
 */
const NotFoundPage = () => {
  return (
    // Contenedor principal que centra el contenido vertical y horizontalmente en toda la pantalla.
    <div className="flex flex-col justify-center items-center h-screen bg-[#0e0f52]">
      
      {/* Logo de la empresa. */}
      <img className='h-40 sombra' src={logo} alt="Logo DS Cyber"/>
      
      {/* Título del error. */}
      <h1 className="text-6xl font-bold mb-4 text-white">Error 404</h1>
      
      {/* Mensaje descriptivo. */}
      <p className="text-lg mb-4 text-white">La página que estás buscando no existe.</p>
      
      {/* Enlace para que el usuario pueda regresar a la página de inicio. */}
      <Link to="/" className="text-black bg-[#92c1de] p-4 rounded-2xl hover:scale-110 transition-transform">
        Volver al inicio
      </Link>
    </div>
  );
};

// Exporta el componente para ser usado en el enrutador de la aplicación.
export default NotFoundPage;
